<div class="grand-parent">
  <div class="container">
    <bulk-chip
      *ngFor="let chip of chips; let i = index; let isLast = last"
      [chip]="chip"
      [chipType]="chipType"
      (remove)="remove(i)"
      (openPatientEdit)="openPatientEdit.emit(chip.patientId)"
      (openSelectContactField)="sendOpenSelectContactField(chip)"
    ></bulk-chip>
  </div>
</div>
